import LoanerLayout from './LoanerLayout';

export default LoanerLayout;